module.exports = __webpack_public_path__ + "img/state-light.d4a1d26d.svg";